<template>
  <span>
    <my-navbar ></my-navbar>    
    <banner :nombreServicio="nombreServicio"></banner>
    <div class="container"> 
        <el-row :gutter="20" id="coaching">
            <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Optimización de Procesos</h1></el-col>
            <br>
            <el-col :xs="24" :md="12">
                <p class="chevere-text-j">Permítenos entrar a tu empresa y conocer como funciona, nosotros encontraremos puntos clave donde optimizar o automatizar procesos o actividades que te ahorren tiempo y dinero siempre ofreciendo soluciones que te permitan mantener la competitividad en el mercado. </p>
            </el-col>
            <el-col class="hidden-md-and-up" :xs="24"><img class="isotipo" src="@/../public/assets/images/services/coaching.jpg" alt=">Optimización de Procesos" title=">Optimización de Procesos"></el-col>

            <el-col class="hidden-sm-and-down" :md="12"><img class="isotipo" src="@/../public/assets/images/services/coaching.jpg" alt=">Optimización de Procesos" title=">Optimización de Procesos"></el-col>
        </el-row>
    
    <tecnologias></tecnologias>
    <contacto></contacto>
    <whatsapp></whatsapp>
    </div>
    <my-footer></my-footer>    
  </span>
</template>

<script>
import Banner from '@/sections/Banner.vue';
import Whatsapp from '@/sections/Whatsapp.vue';
import MyNavbar from '@/sections/Navbar.vue';
import MyFooter from '@/sections/Footer.vue';
import Contacto from '@/sections/Contactanos.vue';
import Tecnologias from '@/sections/Tecnologias.vue';

export default {
  name: "Coaching Informático",
  data () {
    return {
      nombreServicio: "Optimización de procesos"
    }
  },
  components: {    
    Banner,
    Whatsapp,
    Contacto,
    Tecnologias,
    MyNavbar,
    MyFooter
  }
}
</script>

<style>
  .container{
    width: 90%;
    margin: auto;
  }
</style>


// WEBPACK FOOTER //
// src/pages/services/Coaching.vue